import axios from "axios";
import adress from "./tn.json";

export default {
  name: "userAdressSection",
  // created: {
  // },
  data() {
    return {
      model: {
        userId: window.localStorage.getItem("Giftstore-U"),
        phoneNumber: "",
        exactAddress: "",
        region: "",
        city: "",
        postalCode: "",
        // adress: adress
        updateCityUser:[]
      },
    };
  },
  mounted() {

    setTimeout(() => {
      console.log("userInfo", this.$store.getters.getUserInfo);
      if (this.$store.getters.getUserInfo.address) {
        if (this.$store.getters.getUserInfo.address.exactAddress) {
          this.model.exactAddress = this.$store.getters.getUserInfo.address.exactAddress;
        }
        if (this.$store.getters.getUserInfo.address.region) {
          this.model.region = this.$store.getters.getUserInfo.address.region;
        }
        if (this.$store.getters.getUserInfo.address.city) {
          this.model.city = this.$store.getters.getUserInfo.address.city;
        }
        if (this.$store.getters.getUserInfo.address.postalCode) {
          this.model.postalCode = this.$store.getters.getUserInfo.address.postalCode;
        }
        if (this.$store.getters.getUserInfo.phoneNumber) {
          this.model.phoneNumber = this.$store.getters.getUserInfo.phoneNumber;
        }
      }
      this.cityUser()
    }, 500);
  },
  // created(){

  // },
  methods: {
    adressUser() {
      return adress;
    },
    updateAdressUser(){
      this.cityUser()
    },
    cityUser() {
      adress.forEach((element) => {
        if ((element.city ==  this.model.city)) {
          this.updateCityUser= element.region
        }
      });
    },
    updateProfile() {
      axios
        .post("https://giftstore-blog.herokuapp.com/api/user/updateProfile", {
          userId: this.model.userId,
          phoneNumber: this.model.phoneNumber,
          address: {
            exactAddress: this.model.exactAddress,
            region: this.model.region,
            city: this.model.city,
            postalCode: this.model.postalCode,
          },
        })
        .then((response) => {
          this.$store.commit("setUserInfo", response.data.user);
          this.$toast.open({
            message: "Compte bien modifier",
            type: "success",
            // all of other options may go here
          });
        })
        .catch((error) => {
          console.error("There was an error!", error);
          this.$toast.open({
            message: "Erreur lors de la modification",
            type: "error",
            // all of other options may go here
          });
        });
    },
  },
};
